import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../common/theme/ISpcTheme';

export type ButtonViewDetailsClasses = 'button' | 'positionTop' | 'positionBottom';

const buttonViewDetailsStyles = makeStyles<ISpcTheme, ButtonViewDetailsClasses>(
  () => ({
    button: {
      display: 'table-cell',
      verticalAlign: 'middle',
      width: 'auto',
      border: 'none',
      padding: '0px 10px 6px 10px',
      textAlign: 'center',
      position: 'absolute',
    },
    positionTop: {
      borderRadius: '10px 10px 0 0',
      padding: '4px 12px 0px 12px',
      top: -28,
      right: 0,
    },
    positionBottom: {
      borderRadius: '10px 10px 0 0',
      bottom: 0,
      left: '35%',
      maxHeight: 24,
    },
  }),
  { name: 'StickySummary_ButtonViewDetails' },
);

export default buttonViewDetailsStyles;
